import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";
import React, { useEffect, useState } from "react";
import { RxChevronDown, RxChevronUp } from "react-icons/rx";
import {
  formatCrypto,
  formatCurrency,
  getAssetCoin,
  getAssetName,
  normalizeBotName,
} from "../../utils";
import moment from "moment";
import Pagination from "../commons/Pagination";
import SkeletonCard from "../skeletons/SkeletonCard";
import CoinLogo from "../commons/CoinLogo";
import { useSidebar } from "../../context/sidebarContext";

const TablePortoOpenOrders = ({
  openOrders,
  loadingOpenOrders,
  setPage,
  page,
}) => {
  const [expanded, setExpanded] = useState(null);
  const { isMobile } = useSidebar();

  return (
    <div className="bg-white rounded-xl">
      <div>
        {/*  */}
        {loadingOpenOrders ? (
          [...Array(5)].map((_, idx) => (
            <div key={idx} className="border border-[#D2D3D6] rounded-xl mb-4">
              <div className="flex items-center justify-between p-5 rounded-xl cursor-pointer">
                <div className="flex space-x-12">
                  {/* Logo */}
                  <div className="flex items-center">
                    <div className="flex">
                      <div>
                        <SkeletonCard type="avatar" avatarSize={45} />
                      </div>
                      <div className="relative z-[0] ml-[-1rem]">
                        <SkeletonCard type="avatar" avatarSize={45} />
                      </div>
                    </div>
                    <div className="ml-3">
                      <span className="block text-[#8A8383]">Pair</span>
                      <span className="block mt-2">
                        <SkeletonCard
                          type="text"
                          lines={1}
                          widths={["40px"]}
                          heights={["10px"]}
                        />
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center">
                    <div className="ml-3">
                      <span className="block text-[#8A8383]">Exchange</span>
                      <span className="block mt-2">
                        <SkeletonCard
                          type="text"
                          lines={1}
                          widths={["40px"]}
                          heights={["10px"]}
                        />
                      </span>
                    </div>
                  </div>
                </div>
                <button className="!p-0 !m-0 !mr-3 !bg-transparent">
                  <ChevronDownIcon className="w-[24px] h-[24px] text-[#007AFF]" />
                </button>
              </div>
            </div>
          ))
        ) : !!openOrders?.data?.length ? (
          openOrders?.data?.map((item, i) => (
            <div
              key={i}
              className="border border-[#D2D3D6] rounded-xl mb-4"
              onClick={() => {
                if (expanded === i) setExpanded(null);
                else setExpanded(i);
              }}
            >
              <div className="flex items-center justify-between p-3 md:p-5 rounded-xl cursor-pointer">
                <div className="flex space-x-12">
                  {/* Logo */}
                  <div className="flex items-center">
                    <div className="flex items-center -space-x-3 max-md:hidden">
                      <img
                        src={`/images/icons/icon_wallet_${item?.exchange}.svg`}
                        alt=""
                        className="w-full max-w-[40px] h-[40px] rounded-full"
                      />
                      <CoinLogo
                        asset={getAssetName(item?.pair)}
                        className="w-full max-w-[40px] h-[40px] rounded-full"
                      />
                    </div>
                    <div className="md:ml-3 max-md:text-sm">
                      <span className="block text-[#8A8383]">Pair</span>
                      <span className="block mt-2">{item.pair}</span>
                    </div>
                  </div>
                  <div className="flex items-center max-md:text-sm">
                    <div className="ml-3">
                      <span className="block text-[#8A8383]">Exchange</span>
                      <span className="block mt-2">{item.exchange}</span>
                    </div>
                  </div>
                  {/* <div className="flex items-center">
                  <div className="ml-3">
                    <span className="block text-[#8A8383]">Bot</span>
                    <span className="block mt-2">{item.bot}</span>
                  </div>
                </div> */}
                </div>
                <button className="!p-0 !m-0 !mr-3 !bg-transparent">
                  {expanded === i ? (
                    <ChevronUpIcon className="w-[16px] h-[16px] md:w-[24px] md:h-[24px] text-[#007AFF]" />
                  ) : (
                    <ChevronDownIcon className="w-[16px] h-[16px] md:w-[24px] md:h-[24px] text-[#007AFF]" />
                  )}
                </button>
              </div>

              {/* Table */}
              {expanded === i &&
                (isMobile ? (
                  <div>
                    {item.trades.map((order, idx) => (
                      <div className="bg-[#F2F4F8] pt-2 p-4 border-t border-[#D2D3D6] space-y-3">
                        <div className="text-xs flex items-center">
                          <span className="text-[#999999] w-[100px]">BOT</span>
                          <span>{normalizeBotName(order?.bot_name)}</span>
                        </div>
                        <div className="text-xs flex items-center">
                          <span className="text-[#999999] w-[100px]">Type</span>
                          <span>{order?.order_type}</span>
                        </div>
                        <div className="text-xs flex items-center">
                          <span className="text-[#999999] w-[100px]">Side</span>
                          <span
                            className={`${
                              order?.side === "sell"
                                ? "text-red-500"
                                : order?.side === "buy"
                                ? "text-green-600"
                                : ""
                            }`}
                          >
                            Market
                          </span>
                        </div>
                        <div className="text-xs flex items-center">
                          <span className="text-[#999999] w-[100px]">Side</span>
                          <span>{order.side}</span>
                        </div>
                        <div className="text-xs flex items-center">
                          <span className="text-[#999999] w-[100px]">
                            Amount
                          </span>
                          <span>
                            {formatCrypto(order.qty || 0)}{" "}
                            {getAssetName(order?.pair)}
                          </span>
                        </div>
                        <div className="text-xs flex items-center">
                          <span className="text-[#999999] w-[100px]">
                            Total (USDT)
                          </span>
                          <span>{formatCrypto(order.price || 0)}</span>
                        </div>
                        <div className="text-xs flex items-center">
                          <span className="text-[#999999] w-[100px]">Date</span>
                          <span>
                            {moment(order.created_at).format(
                              "DD/MM/YYYY HH:mm"
                            )}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div
                    className="bg-[#F2F4F8] pt-2 p-4 border-t border-[#D2D3D6] rounded-bl-xl rounded-br-xl"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <table className="min-w-full text-sm text-left">
                      <thead>
                        <tr>
                          {[
                            "Bot",
                            "Type",
                            "Side",
                            "Amount",
                            "Price",
                            "Total",
                            "Date",
                          ].map((header, i) => (
                            <th
                              key={i}
                              className="px-3 py-2 font-bold text-[#21272A]"
                            >
                              {header}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {item.trades.map((order, idx) => (
                          <tr className="border-b" key={order.id}>
                            <td className="px-3 py-3 text-sm">
                              {normalizeBotName(order?.bot_name)}
                            </td>
                            <td className="px-3 py-3 text-sm">
                              {order?.order_type}
                            </td>
                            <td
                              className={`px-3 py-2 text-sm font-semibold capitalize ${
                                order.side === "sell"
                                  ? "text-red-500"
                                  : order.side === "buy"
                                  ? "text-green-600"
                                  : ""
                              }`}
                            >
                              {order.side}
                            </td>
                            <td className="px-3 py-3 text-sm">
                              {formatCrypto(order.qty || 0)}{" "}
                              {getAssetName(order?.pair)}
                            </td>
                            <td className="px-3 py-3 text-sm">
                              {formatCrypto(order.price || 0)}
                            </td>
                            <td className="px-3 py-3 text-sm">
                              {formatCurrency(order.usdt_qty || 0)} {item.pair?.split("/")?.[1] || "USDT"}
                            </td>
                            <td className="px-3 py-3 text-sm">
                              {moment(order.created_at).format(
                                "DD/MM/YYYY HH:mm"
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ))}
            </div>
          ))
        ) : (
          <div className="bg-white rounded-xl mt-6 h-[10rem] flex items-center  p-3 text-sm justify-center text-center text-gray-400">
            No data found.
          </div>
        )}
        {/*  */}
      </div>

      <div className="items-center justify-center mt-4 md:mt-6 flex">
        <Pagination
          currentPage={page}
          totalPages={openOrders?.pagination?.max_page || 1}
          onPageChange={setPage}
        />
      </div>
    </div>
  );
};

export default TablePortoOpenOrders;
